// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__12EEM","disabled":"FileBtn_disabled__26fV8","warn":"FileBtn_warn__3C_BY","fade":"FileBtn_fade__2YwG8"};